import {Pipe, PipeTransform} from '@angular/core';
import {Column, TableService} from 'app/shared/service/table.service';

/**
 * Renvoie la class CSS d'alignement pour un colonne en fonction de son type.
 */
@Pipe({name: 'tableAlignClass'})
export class TableAlignClassPipe implements PipeTransform {

    constructor(public tableService: TableService) {
    }

    transform(column: Column): string {
        return this.tableService.getAlignClass(column);
    }
}
